import { decrementPendingActionsCount } from "@/features/auth";
import { baseApi } from "./index";

export const onboardingApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    acknowledgeHiringOrder: builder.mutation<
      { message: string; acknowledged: boolean; acknowledged_at: string },
      void
    >({
      query: () => ({
        url: "/api/self/onboarding/order/acknowledge/",
        method: "POST",
        credentials: "include" as const,
      }),
      invalidatesTags: [
        "PendingActions",
        { type: "SelfService" as const, id: "PROFILE" },
      ],
      async onQueryStarted(_, { dispatch, queryFulfilled }) {
        await queryFulfilled;
        dispatch(decrementPendingActionsCount());
      },
    }),
  }),
});

export const { useAcknowledgeHiringOrderMutation } = onboardingApi;
